export const CASES = {
  UPDATE_RATE_CARDS: "UPDATE_RATE_CARDS",
  UPDATE_RATE_CARDS_SEARCH_FORM: "UPDATE_RATE_CARDS_SEARCH_FORM",
  UPDATE_RATE_CARD_FORM: "UPDATE_RATE_CARD_FORM",
  CLEAR_RATE_CARDS: "CLEAR_RATE_CARDS",
  CLEAR_RATE_CARD_FORM: "CLEAR_RATE_CARD_FORM",
};
